module.exports = __webpack_public_path__ + "img/LTS_PKF.ae4cb648.gif";